import React from 'react';
import {Link} from 'react-router-dom';
import {Row,Col,Container,Image} from 'react-bootstrap';

class NotFound extends React.Component {

	render() {
    	return (
    		<section className="section pt-5 pb-5 osahan-not-found-page">
		         <Container>
		            <Row>
		               <Col md={12} className="text-center pt-5 pb-5">
		                  <Image className="img-fluid" src="/img/404.png" alt="404" />
		                  <h1 className="mt-2 mb-2">Error 404</h1>
		                  <p>Es tut uns Leid, die von Ihnen gesuchte Seite konnte nicht gefunden werden.​ <br />Möglicherweise haben Sie die Adresse falsch eingegeben oder die Seite wurde verschoben.</p>
		                  <Link className="btn btn-primary" to="/">Home</Link>
		               </Col>
		            </Row>
		         </Container>
		    </section>
    	);
    }
}


export default NotFound;